import {Mutex} from 'async-mutex';
import {useEffect} from 'react';
import {HttpClientEnhancer} from '../HttpClient';

export const withMutexes = (...locks: Mutex[]): HttpClientEnhancer => {
    return http => async (url, init) => {
        if (isLocked()) {
            await untilAllUnlocked();
        }
        const response = await http(url, init);
        if (isLocked()) {
            await untilAllUnlocked();
        }
        return response;
    };

    function isLocked() {
        return locks.some(lock => lock.isLocked());
    }

    function untilAllUnlocked() {
        return Promise.all(locks.filter(lock => lock.isLocked()).map(lock => lock.waitForUnlock()));
    }
};

export const createHttpLock = () => {
    const lock = new Mutex();
    return lock;
};

export const useLockEffect = (lock: Mutex, enabled = true) => {
    useEffect(() => {
        if (enabled) {
            lock.acquire();
            return () => lock.release();
        }
    }, [enabled]);
};
